import { SettingsReducer } from './types';

export const reducer: SettingsReducer = (state, action) => {
  if (action.type === 'GAME_SEARCH_ACTIVE') {
    return {
      ...state,
      isGameSearchActive: action.payload
    };
  }
  if (action.type === 'SHOW_PWA_POPUP') {
    return {
      ...state,
      isPwaPopupVisible: action.payload
    };
  }
  if (action.type === 'SET_COOKIES_ACCEPTED') {
    localStorage.setItem('cookiesAccepted', 'true');
    return {
      ...state,
      isCookiesAccepted: true
    };
  }
  return state;
};

export function inferLiteralFromString<T extends string>(arg: T): T {
  return arg;
}
